const tabsTiles = document.querySelector('.layout-tabs-tiles');

if (tabsTiles && !tabsTiles.classList.contains('js-processed')) {
  tabsTiles.classList.add('js-processed');

  const tilesTitles = tabsTiles.querySelectorAll('.block-tab-tiles__title');

  const toggleHolder = document.querySelector(
    '.layout-tabs-titles__toggle-holder',
  );

  tilesTitles.forEach((title, index) => {
    // Create button per tab set
    const buttonToggle = document.createElement('button');
    buttonToggle.innerHTML = title.innerHTML;
    buttonToggle.classList.add('layout-tabs-titles__toggle-btn');
    buttonToggle.setAttribute('role', 'tab');
    // Get button target ID from title
    const buttonTarget = title.getAttribute('data-title-id');
    if (index === 0) {
      buttonToggle.setAttribute('aria-expanded', true);
    } else {
      buttonToggle.setAttribute('aria-expanded', false);
      // If it's not the first tabpanel we add a hidden class
      title.parentNode.setAttribute('aria-hidden', true);
    }
    // Add target ID to button
    buttonToggle.setAttribute('aria-controls', `${buttonTarget}`);
    // Attach buttons to tab holder
    toggleHolder.appendChild(buttonToggle);
  });

  const allToggleButtons = toggleHolder.querySelectorAll('button');
  // Sort click events to hide and show tabs
  allToggleButtons.forEach((singleButton) => {
    singleButton.addEventListener('click', function () {
      // Remove aria-expanded from other buttons
      allToggleButtons.forEach((button) => {
        button.setAttribute('aria-expanded', false);
      });

      // Get button target ID
      const buttonTarget = singleButton.getAttribute('aria-controls');

      // Hide all tabs
      tilesTitles.forEach((tile) => {
        tile.parentNode.setAttribute('aria-hidden', true);

        // Check match for Tabpanel ID and button target
        if (tile.parentNode.getAttribute('id') === buttonTarget) {
          singleButton.setAttribute('aria-expanded', true);
          tile.parentNode.setAttribute('aria-hidden', false);
        }
      });
    });
  });
}
